import { Box, Typography } from '@mui/material';
import { useUtils } from 'utils/dateUtils';

import { EditableClockInput } from '../EditableClockInput/EditableClockInput';
import { useClockViewStyles } from './ClockView.styles';

type ClockViewProps = {
  date: any;
  onChange: (date: any) => void;
  ampm?: boolean;
};

export const ClockView = ({ date, onChange, ampm }: ClockViewProps) => {
  const utils = useUtils();

  const hours = utils.getHourText(date, ampm);
  const minutes = utils.getMinuteText(date);

  const classes = useClockViewStyles();

  const handleTimeChange = (value: number, type: 'minutes' | 'hours') => {
    if (type === 'minutes') {
      onChange(utils.setMinutes(date, value));
    } else {
      onChange(utils.setHours(date, value));
    }
  };

  return (
    <Box
      className={classes.container}
      // style={{ maxWidth: 160 }}
      display="flex"
      alignItems="center"
    >
      <EditableClockInput
        value={hours}
        onChange={value => handleTimeChange(value, 'hours')}
        maxValue={ampm ? 11 : 23}
      />

      <Typography variant="h5" style={{ fontWeight: 'bolder' }}>
        :
      </Typography>

      <EditableClockInput
        value={minutes}
        onChange={value => handleTimeChange(value, 'minutes')}
        maxValue={59}
      />
    </Box>
  );
};
